import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Subscription from "@/services/billing/subscription";

export interface StripeSessionInfo {
  status?: string;
  [key: string]: unknown;
}

export function useStripeSessionInfo(sessionId: Ref<string | undefined>) {
  const queryKey = computed(() => ["stripeSessionInfo", sessionId.value] as const);

  const enabled = computed(() => Boolean(sessionId.value));

  return useQuery({
    queryKey,
    queryFn: async (): Promise<StripeSessionInfo> => {
      const id = sessionId.value;
      if (!id) throw new Error("No session ID");

      const result = await Subscription.getStripeSessionInfo(id);
      if (result?.data?.status && result.data.data != null) {
        return result.data.data as StripeSessionInfo;
      }
      throw new Error("Failed to fetch session info");
    },
    enabled,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 8000),
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  });
}
